import { render, staticRenderFns } from "./ModalEditAccount.vue?vue&type=template&id=2a0fc452&"
import script from "./ModalEditAccount.vue?vue&type=script&lang=js&"
export * from "./ModalEditAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports